import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const RefundPage = () => {
  return (
    <div className="legal-page">
      <SEO
        title="Refund Policy — 24-Hour Satisfaction Guarantee"
        description="PathProxy offers a 24-hour satisfaction guarantee. Request a full refund within 24 hours if less than 10% bandwidth used. Cryptocurrency refunds processed in original currency."
        path="/refund"
      />
      <Navbar />

      <section className="legal-hero">
        <div className="container">
          <h1 className="legal-title">Refund Policy</h1>
          <p className="legal-subtitle">Last updated: January 2026</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <p className="legal-intro">
              At pathproxy, we want you to be satisfied with our services. This Refund Policy
              outlines the conditions under which refunds may be granted.
            </p>

            <h2>1. Refund Eligibility</h2>
            <p>
              You may request a refund within <strong>24 hours</strong> of your initial purchase if:
            </p>
            <ul>
              <li>The service does not work as described and our support team cannot resolve the issue</li>
              <li>You experience persistent connectivity issues that prevent normal use</li>
              <li>There are significant discrepancies between advertised and actual service features</li>
            </ul>

            <h2>2. Refund Process</h2>
            <p>To request a refund:</p>
            <ol>
              <li>Contact our support team within 24 hours of purchase</li>
              <li>Provide your order ID and account email</li>
              <li>Describe the issue you experienced in detail</li>
              <li>Allow our team to attempt to resolve the issue first</li>
            </ol>
            <p>
              Refund requests are typically processed within 3-5 business days after approval.
            </p>

            <h2>3. Non-Refundable Situations</h2>
            <p>Refunds will NOT be granted in the following cases:</p>
            <ul>
              <li>Requests made more than 24 hours after purchase</li>
              <li>Significant usage of the service before requesting refund (more than 10% of allocated bandwidth)</li>
              <li>Account termination due to Terms of Service violations</li>
              <li>Change of mind or no longer needing the service</li>
              <li>Issues caused by your own equipment, network, or configuration</li>
              <li>Incompatibility with third-party software not listed in our documentation</li>
              <li>Service worked as intended but did not meet personal expectations</li>
            </ul>

            <h2>4. Partial Refunds</h2>
            <p>
              In some cases, we may offer partial refunds or service credits:
            </p>
            <ul>
              <li>Service downtime exceeding guaranteed uptime (99.9%)</li>
              <li>Technical issues that affected service quality for extended periods</li>
              <li>Billing errors or duplicate charges</li>
            </ul>
            <p>
              Partial refunds are calculated based on the unused portion of your subscription
              and the nature of the issue.
            </p>

            <h2>5. Cryptocurrency Payments</h2>
            <p>
              For payments made with cryptocurrency:
            </p>
            <ul>
              <li>Refunds will be issued in the same cryptocurrency used for payment</li>
              <li>The refund amount will be based on the USD value at the time of original purchase</li>
              <li>We are not responsible for cryptocurrency value fluctuations</li>
              <li>You must provide a valid wallet address for the refund</li>
            </ul>

            <h2>6. Service Credits</h2>
            <p>
              As an alternative to monetary refunds, we may offer service credits that can be
              applied to future purchases. Service credits:
            </p>
            <ul>
              <li>Do not expire as long as your account remains active</li>
              <li>Cannot be transferred to other accounts</li>
              <li>Cannot be converted to cash</li>
            </ul>

            <h2>7. Subscription Cancellation</h2>
            <p>
              If you wish to cancel your subscription:
            </p>
            <ul>
              <li>You may cancel at any time through your dashboard</li>
              <li>Access continues until the end of your current billing period</li>
              <li>No prorated refunds for unused time in the current period</li>
              <li>Future charges will be stopped immediately</li>
            </ul>

            <h2>8. Disputes</h2>
            <p>
              If you disagree with our refund decision:
            </p>
            <ul>
              <li>Contact our support team to escalate the issue</li>
              <li>Provide additional information or evidence supporting your claim</li>
              <li>A senior team member will review your case within 48 hours</li>
            </ul>
            <p>
              We strive to resolve all disputes fairly and professionally.
            </p>

            <h2>9. Chargebacks</h2>
            <p>
              Before initiating a chargeback with your bank or payment provider, please contact
              our support team first. Chargebacks:
            </p>
            <ul>
              <li>May result in immediate account termination</li>
              <li>Can delay resolution and incur additional fees</li>
              <li>Should only be used after exhausting our refund process</li>
            </ul>

            <h2>10. Contact for Refunds</h2>
            <p>
              To request a refund or discuss billing issues, contact us through:
            </p>
            <ul>
              <li>Support ticket system in your dashboard (fastest response)</li>
              <li>Our Discord server</li>
              <li>Telegram support</li>
            </ul>
            <p>
              Please include your order ID and account email in all refund communications.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RefundPage;
